import { getEvents } from '@app/analytics/models/helpers';
import { TagContainer } from '@app/analytics/models/container';
import { AddToWishlistSuccess } from '@app/+product/store/actions/product.action';

/**
 * When a product is added to Wishlist.
 */
const events = getEvents((action: AddToWishlistSuccess) => [
  {
    type: 'event',
    container: TagContainer.Analytics,
    payload: {
      event: 'productAddToWishlist',
      addToWishlistType: 'product_page',
      product_brand: action.payload.brand.name,
      product_category: action.payload.category.name,
      product_univers: action.payload.universe.name
    }
  },
  {
    type: 'add_to_WL',
    container: TagContainer.Media
  }
]);

export default events;
